<template>
  <div class="mt-4 px-5">
    <v-alert dense text shaped type="info">
      <b>Arbeitsstunden-Funktionen</b>
      <div>
        Legen Sie hier fest, welche Tätigkeiten (Funktionen) als Arbeitsstunden angerechnet werden sollen.
      </div>
    </v-alert>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="localFunctions"
        :loading="loading"
        hide-default-footer
        disable-pagination
        class="elevation-1"
      >
        <template v-slot:item.is_arbeitsstunden_relevant="{ item }">
          <v-switch
            v-model="item.is_arbeitsstunden_relevant"
            dense
            hide-details
          ></v-switch>
        </template>
        <template v-slot:item.is_active="{ item }">
          <v-switch
            v-model="item.is_active"
            dense
            hide-details
          ></v-switch>
        </template>
      </v-data-table>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveChanges" :loading="saving">
          Änderungen speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "WorkinghoursFunctions",
  data() {
    return {
      loading: false,
      saving: false,
      localFunctions: [],
      headers: [
        { text: "Funktion", value: "name" },
        { text: "Arbeitsstunden-relevant", value: "is_arbeitsstunden_relevant", sortable: false },
        { text: "Aktiv", value: "is_active", sortable: false },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        await this.$store.dispatch("ClubApp/getArbeitsstundenFunctions");
        // Lokale Kopie für v-switches (v-model auf Store-State ist nicht empfohlen ohne setter)
        this.localFunctions = this.$store.state.ClubApp.ArbeitsstundenFunctions.map(f => ({
          ...f,
          is_arbeitsstunden_relevant: !!f.is_arbeitsstunden_relevant,
          is_active: !!f.is_active
        }));
      } catch (error) {
        console.error("Fehler beim Laden der Funktionen:", error);
      } finally {
        this.loading = false;
      }
    },
    async saveChanges() {
      this.saving = true;
      try {
        const payload = {
          functions: this.localFunctions.map(f => ({
            shooting_function_id: f.shooting_function_id || f.id,
            is_arbeitsstunden_relevant: f.is_arbeitsstunden_relevant ? 1 : 0,
            is_active: f.is_active ? 1 : 0
          }))
        };
        await this.$store.dispatch("ClubApp/bulkUpdateArbeitsstundenFunctions", payload);
        this.fetchData();
      } catch (error) {
        console.error("Fehler beim Speichern der Funktionen:", error);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
